import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";

export const PayrollInsurableEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Insurable Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll Insurable Earnings", navigateTo: "/company/payrollInsurableEarnings/setup" }
      ]}
      mainContents={<PayrollInsurableEarningsSetup />}
    />
  );
};
